import { InAppState } from "../base/InAppState";
import template from './TemplateEditTemplate.html';

export class TemplateEditState extends InAppState
{
    static ROUTE = '/template/edit/:templateId';
    static ID = 'template-edit';

    constructor( app, rp )
    {
        super( app, rp );
        this.templateId = rp.getParam( 'templateId' );
    }

    async enter()
    {
        this.template = null;

        const { result } = await this.app.api.get( `/template/${this.templateId}` );
        if ( result.status === 200 && result.data )
        {
            this.template = result.data;
        }
        else
        {
            this.app.view.toast( 'Failed to load template', 'error' );
            this.app.router.redirect( '/template/list' );
            return;
        }

        this.render();
        this._bindSubmit();
    }

    _bindSubmit()
    {
        const pageContent = this.app.view.pageContent;
        const form = pageContent.querySelector( '#template-form' );

        this.addEventListener( pageContent.querySelector( '[data-id="submit-form"]' ), 'click', async ( e ) =>
        {
            e.preventDefault();

            if ( !form.checkValidity() )
            {
                form.classList.add( 'was-validated' );
                return;
            }

            form.classList.remove( 'was-validated' );
            this.app.view.blockUI( pageContent, 'Saving changes...' );

            const nameInput = form.querySelector( '[name="name"]' );
            const descriptionInput = form.querySelector( '[name="description"]' );
            const fileInput = form.querySelector( '#template-file' );

            const formData = new FormData();
            formData.append( 'name', nameInput.value.trim() );
            formData.append( 'description', descriptionInput?.value || '' );

            if ( fileInput?.files?.length > 0 )
            {
                formData.append( 'file', fileInput.files[0] );
            }

            try
            {
                const response = await fetch( `${this.app.api.getUrl()}/template/${this.templateId}`, {
                    method: 'PATCH',
                    headers: {
                        'x-sessiontoken': this.app.api._api.headers.get( 'x-sessiontoken' ),
                        'x-version': this.app.api._api.headers.get( 'x-version' )
                    },
                    body: formData
                });

                this.app.view.unblockUI( pageContent );

                if ( response.ok )
                {
                    this.app.view.toast( 'Template updated successfully', 'success' );
                    this.app.router.redirect( `/template/view/${this.templateId}` );
                }
                else
                {
                    const errorData = await response.json().catch( () => null );
                    const errorMessage = errorData?.message || 'Failed to update template';
                    this.app.view.toast( errorMessage, 'error' );
                }
            }
            catch ( error )
            {
                console.error( error );
                this.app.view.unblockUI( pageContent );
                this.app.view.toast( 'An error occurred while updating the template', 'error' );
            }
        });
    }

    render()
    {
        this.app.view.render(
            this.app.view.pageContent,
            template,
            {
                template: this.template
            }
        );
    }

    getContentHeaderData()
    {
        return {
            title: 'Edit Template',
            breadcrumb: [ 'Work', 'Templates', 'Edit template' ]
        };
    }
}
